module.exports = __webpack_public_path__ + "img/baumliste-active.bb269904.svg";